export default {
      id: "cleaning_services-usage",
      viewBox: "0 0 24 24",
      url: __webpack_public_path__ + "img/icons.845ff42f.svg#cleaning_services",
      toString: function () {
        return this.url;
      }
    }